/**
Functionality: 頁面Footer
Author: Neil
Date: 2019/12/04

*/
<template>
  <footer>
    <span>Copyright © {{ curYear }}, ProfetAI Inc. rights reserved.</span>
  </footer>
</template>
<script>
export default {
  computed: {
    curYear() {
      return new Date().getFullYear().toString()
    }, // curYear()
  }, // End of computed
} // End of export 
</script>
<style lang="scss" scoped>
  footer{
    color: #fff;
    width: 100%;
    height:32px;
    text-align: center;
    margin-top: 20px;
  }
</style>